import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import { PersonIdentityComponent } from '../../../../../sharedLegacy/components'

import './AudienceInsetProfilesComponent.scss'

const renderProfile = (profile, identityOptions, style) => {
  return (
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    <a
      href={`/audience/${profile.uuid}`}
      target="_blank"
      rel="noopener noreferrer"
      key={profile.uuid}
    >
      <PersonIdentityComponent
        person={profile}
        avatarSize={identityOptions.avatarSize}
        preferCorporateDetails={identityOptions.preferCorporateDetails}
        showStats={identityOptions.showStats}
        style={style}
      />
    </a>
  )
}

const AudienceInsetProfilesComponent = ({
  profiles,
  identityOptions,
  style,
}) => {
  return (
    <div className="audience-inset-profiles-component">
      {profiles
        .toArray()
        .map((profile) => renderProfile(profile, identityOptions, style))}
    </div>
  )
}

AudienceInsetProfilesComponent.propTypes = {
  profiles: ImmutablePropTypes.orderedMap,
  identityOptions: PropTypes.shape({
    avatarSize: PropTypes.oneOf(['normal', 'large', 'small']),
    preferCorporateDetails: PropTypes.bool,
    showStats: PropTypes.bool,
  }),
  style: PropTypes.object,
}

export default AudienceInsetProfilesComponent
